import React from 'react';
import { Box } from '@mui/material';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 3,
        px: { xs: 4, md: 6 },
        py: 5,
        borderTop: '1px solid #1E3040',
        background: '#0D1821',
      }}
    >
      <Box sx={{
        fontSize: '11px',
        letterSpacing: '1px',
        color: '#2A4560',
        fontFamily: "'Barlow', sans-serif",
      }}>
        © {year} Rak Digital Developments. All rights reserved.
      </Box>
      <Box sx={{ display: 'flex', gap: 4 }}>
        {[
          { label: 'GitHub', href: 'https://github.com/RakOnTrack' },
          { label: 'LinkedIn', href: 'https://www.linkedin.com/in/eric-rak-tech/' },
        ].map(({ label, href }) => (
          <Box
            key={label}
            component="a"
            href={href}
            target="_blank"
            rel="noopener"
            sx={{
              fontSize: '10px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color: '#2A4560',
              fontFamily: "'Barlow', sans-serif",
              textDecoration: 'none',
              transition: 'color 0.2s',
              '&:hover': { color: '#FF914D' },
            }}
          >
            {label}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default Footer;
